/* eslint-disable */ 

if (process.env.NODE_ENV !== 'production') {
  const url = new URL(document.currentScript.src);
  __webpack_public_path__ = (url.origin + __webpack_public_path__);
}

